"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentTypeSnippetElementsBuilder = exports.ContentTypeSnippetElements = void 0;
class ContentTypeSnippetElements {
    assetElement(element) {
        return element;
    }
    customElement(element) {
        return element;
    }
    dateTimeElement(element) {
        return element;
    }
    guidelinesElement(element) {
        return element;
    }
    linkedItemsElement(element) {
        return element;
    }
    subpagesElement(element) {
        return element;
    }
    multipleChoiceElement(element) {
        return element;
    }
    numberElement(element) {
        return element;
    }
    richTextElement(element) {
        return element;
    }
    taxonomyElement(element) {
        return element;
    }
    textElement(element) {
        return element;
    }
    any(element) {
        return element;
    }
}
exports.ContentTypeSnippetElements = ContentTypeSnippetElements;
exports.contentTypeSnippetElementsBuilder = new ContentTypeSnippetElements();
//# sourceMappingURL=content-type-snippet-elements.builder.js.map